<div class="loading-bar">
  <div class="loading-bar__fill"></div>
</div>
